import React, { useEffect, useRef } from 'react';
import { BuilderProduct, actions as builderActions } from "@/store/builderSlice";
import { useDispatch } from 'react-redux';
import { Box, Tooltip, Typography } from '@mui/material';
import { useDrag } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { isMobile } from 'react-device-detect';



export default function DraggableThumbnail(props: { id: string; url: string; asset: any, tooltipText: string }) {
    const dispatch = useDispatch();
    const imageRef = useRef<HTMLImageElement | null>(null);

    const [{ opacity }, drag, preview] = useDrag(() => ({
        type: 'box',
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
            opacity: monitor.isDragging() ? 1 : 1,
        }),
        item: (monitor) => {
            //return props.asset;
            return { ...props.asset, imageRef: imageRef.current };
        }
    }))
    const handleImageLoad = (event: any) => {
        const imgElement = getImageElement(10, 10);
        //preview(imgElement, { offsetX: imgElement.width / 2, offsetY: imgElement.height / 2 });
    };
    useEffect(() => {
        preview(getEmptyImage(), { captureDraggingState: true })
    }, []);


    const getImageElement = (width: number, height: number) => {
        const imgElement = new Image();
        imgElement.src = props.url;
        imgElement.width = width;
        imgElement.height = height;
        return imgElement;
    };

    return (
        <>
            {isMobile ? (
                <Box
                    component={'div'}
                    data-testid="product-thumbnail"
                    draggable={false}
                    style={{ cursor: 'grab' }}
                >
                    <img
                        src={props.url}
                        style={{ maxWidth: '30px', zIndex: 1000000 }}
                        draggable={false}
                        onLoad={handleImageLoad}
                        ref={imageRef}
                    />
                </Box>
            ) : (
                <Box
                    component={'div'}
                    data-testid="product-thumbnail"
                    draggable={false}
                    ref={drag}
                    style={{ cursor: 'grab' }}>
                    <Tooltip
                        title={<Typography fontSize={14} color={'white'}>{props.tooltipText}</Typography>}
                        arrow
                        PopperProps={{
                            style: { zIndex: 99999999, width: 200, opacity: 0.75 },
                            modifiers: [
                                {
                                    name: "offset",
                                    options: {
                                        offset: [0, 0],
                                    },
                                },
                            ],
                        }}
                        placement="right"

                    >
                        <img
                            src={props.url}
                            style={{ maxWidth: '80px', zIndex: 1000000 }}
                            draggable={false}
                            onLoad={handleImageLoad}
                            ref={imageRef}
                        />
                    </Tooltip>
                </Box>
            )}
        </>
    );
}
